import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Collapse, Paper } from '@material-ui/core'

import PermissionMatrixHeader from './components/PermissionMatrixHeader'
import PermissionMatrixRow from './components/PermissionMatrixRow'
import { columnShape, sectionShape } from './propTypes'
import useStyles from './styles'

const PermissionMatrix = ({
  icon,
  title,
  columns,
  sections,
  collapsible = false,
  defaultExpanded = true,
  disabledHint,
  onChange,
  accentColor = null, // cor da borda superior do Paper — aplica borderTop: 4px solid
}) => {
  const classes = useStyles()
  const [expanded, setExpanded] = useState(collapsible ? defaultExpanded : true)
  const isOpen = collapsible ? expanded : true

  return (
    <Paper
      className={classes.root}
      elevation={0}
      style={{
        ...(accentColor && { borderTop: `4px solid ${accentColor}` }),
      }}
    >
      <PermissionMatrixHeader
        icon={icon}
        title={title}
        columns={columns}
        collapsible={collapsible}
        expanded={isOpen}
        onToggle={() => setExpanded((previous) => !previous)}
      />
      <Collapse in={isOpen}>
        {sections.map((section, sectionIndex) => (
          <Box key={`${section.label}-${sectionIndex}`}>
            <Box className={classes.sectionLabel}>
              <span>{section.label}</span>
              <span className={classes.sectionRule} />
            </Box>
            {section.rows.map((row) => (
              <PermissionMatrixRow
                key={row.id}
                row={row}
                columns={columns}
                disabledHint={disabledHint}
                onChange={onChange}
              />
            ))}
          </Box>
        ))}
      </Collapse>
    </Paper>
  )
}

PermissionMatrix.propTypes = {
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  columns: PropTypes.arrayOf(columnShape).isRequired,
  sections: PropTypes.arrayOf(sectionShape).isRequired,
  collapsible: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
  disabledHint: PropTypes.string,
  onChange: PropTypes.func,
  accentColor: PropTypes.string,
}

export default PermissionMatrix
